import * as React from 'react';
import { useControls } from 'leva';
import tunnel from 'tunnel-rat';
import { Canvas } from '@react-three/fiber';
import Model from './Model';
import { ContactShadows, OrbitControls } from '@react-three/drei';

export type Props = {};

const MODEL_MAP = {
  Beech: 'https://vazxmixjsiawhamofees.supabase.co/storage/v1/object/public/models/tree-beech/model.gltf',
  Lime: 'https://vazxmixjsiawhamofees.supabase.co/storage/v1/object/public/models/tree-lime/model.gltf',
  Spruce: 'https://vazxmixjsiawhamofees.supabase.co/storage/v1/object/public/models/tree-spruce/model.gltf',
} as const;

type Model = keyof typeof MODEL_MAP;

const MODELS = Object.keys(MODEL_MAP) as unknown as Model[];

const status = tunnel();

function App01(props: Props) {
  const {} = props;
  const { model } = useControls({
    model: {
      value: MODELS[0],
      options: MODELS,
    },
  });

  return (
    <div style={{ widows: '100%', height: '200px', marginBottom: '4rem' }}>
      <header>
        <p>{model}</p>
        <status.Out />
      </header>
      <Canvas camera={{ position: [-10, 10, 40], fov: 50 }}>
        <hemisphereLight intensity={0.75} color="white" groundColor={'blue'} />
        <spotLight position={[50, 50, 10]} angle={0.15} penumbra={1} />

        <group position={[0, -10, 0]}>
          <React.Suspense fallback={<status.In>Loading...</status.In>}>
            <Model position={[0, 0.25, 0]} url={MODEL_MAP[model] as string} />
          </React.Suspense>
          <ContactShadows scale={20} blur={10} far={20} />
        </group>

        <mesh>
          <boxGeometry args={[1, 1, 1]} />
          <meshStandardMaterial color="orange" />
        </mesh>
        <OrbitControls />
      </Canvas>
    </div>
  );
}

export default React.memo(App01);
